import * as React from 'react';
const SvgIcon = props => {
  if (props?.size == 'lg') {
    return <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
        <path d="M230.26-190.26h148.46v-242.56h202.56v242.56h148.46v-374.61L480-753.08 230.26-564.96zM180-140v-450l300-225.77L780-590v450H531.03v-242.57H428.97V-140zm300-331.87"></path>
      </svg>;
  }
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
      <path d="M240-200h133.85v-237.69h212.3V-200H720v-360L480-740.77 240-560zm-60 60v-450l300-225.77L780-590v450H526.15v-237.69h-92.3V-140zm300-330.38"></path>
    </svg>;
};
export default React.memo(SvgIcon);